export class RogueTrackerActions {
  id: number;
  actionType: string;
  actionDisplay: string;
  updateTimestamp: Date;
}
